(function(config) {
    'use strict';

    angular.module('caffeprint').filter('unixToDate', unixToDate);

    unixToDate.$inject = [];

    function unixToDate() {
        return function(unixTimestamp) {
            var date = new Date(unixTimestamp * 1000); // convert Unix timestamp to milliseconds
            return date.toLocaleTimeString(); // display time in user's locale format
        };
    }
})(window.config);
